import { Box, Center, Flex, Text } from '@chakra-ui/react';
import { useField } from 'formik';

import { SchemaQuestion, labelForValue } from '../encodeDecodeAnswers';
import { matchesGoodValue } from './conditionGoodValues';

type StatusRadioCardProps = {
  question: SchemaQuestion;
  goodValue?: string | string[];
};

const StatusRadioCard = ({ question, goodValue }: StatusRadioCardProps) => {
  const [field, , helpers] = useField(question.questionId);
  const value = typeof field.value === 'string' ? field.value : '';
  const options = question.options ?? [];
  const selectedLabel = value ? labelForValue(question.options, value) : '';
  const isGood = matchesGoodValue(value, goodValue);

  const headerBg = value ? (isGood ? 'iceBlue' : 'amberLight') : 'white';
  const borderColor = value ? (isGood ? 'oceanBoatBlue' : 'bananaMania') : 'gray.200';
  const titleColor = value ? (isGood ? 'oceanBoatBlue' : 'darkGoldenrod') : 'leaseEndBlue';

  return (
    <Box
      border="1.5px solid"
      borderColor={borderColor}
      borderRadius="14px"
      overflow="hidden"
      mb={3}
    >
      <Flex
        align="center"
        justify="space-between"
        p="14px 16px"
        bg={headerBg}
        transition="all 0.15s ease"
      >
        <Text fontSize="md" fontWeight="700" color={titleColor}>
          {question.label}
        </Text>
        {selectedLabel && (
          <Box
            px="8px"
            py="3px"
            borderRadius="full"
            bg={isGood ? 'iceBlue' : 'amberLight'}
            color={isGood ? 'oceanBoatBlue' : 'darkGoldenrod'}
            fontSize="xs"
            fontWeight="700"
          >
            {selectedLabel}
          </Box>
        )}
      </Flex>
      <Box role="radiogroup" aria-label={question.label} px={4} pb={3} pt={1} bg="white">
        {options.map((o, i) => {
          const selected = value === o.value;
          return (
            <Flex
              as="button"
              type="button"
              role="radio"
              aria-checked={selected}
              key={o.value}
              onClick={() => helpers.setValue(o.value)}
              align="center"
              gap={3}
              py="10px"
              w="100%"
              textAlign="left"
              borderTop={i === 0 ? undefined : '1px solid'}
              borderColor="grayLightBackground"
            >
              <Center
                w="20px"
                h="20px"
                borderRadius="full"
                border="2px solid"
                borderColor={selected ? 'oceanBoatBlue' : 'gainsboro'}
                bg={selected ? 'oceanBoatBlue' : 'transparent'}
                flexShrink={0}
              >
                {selected && <Box w="7px" h="7px" borderRadius="full" bg="white" />}
              </Center>
              <Text
                fontSize="sm"
                color={selected ? 'leaseEndBlue' : 'grayDark'}
                fontWeight={selected ? '600' : '400'}
              >
                {o.label}
              </Text>
            </Flex>
          );
        })}
      </Box>
    </Box>
  );
};

export default StatusRadioCard;
